import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import WifiManagementBlockData from '../../../Models/Content/WifiManagementBlockData';
import WifiManagement from './WifiManagementBlock';

export default class WifiManagementBlock extends EpiComponent<WifiManagementBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['wifi-management-block'];

    return (
      <div className={cssClasses.join(" ")}>
            <WifiManagement iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}

